import { Image } from "../Images";

// Images to preload - add all critical images that should be loaded before showing content
const CRITICAL_IMAGES = [
  Image.HEROBANNER,
  Image.HEROBANNER_MOBILE,
  Image.LOGO_WHITE,
  Image.LOGO_BLACK
];

export const preloadImages = (): Promise<void[]> => {
  const imagePromises = CRITICAL_IMAGES.map(src => {
    return new Promise<void>((resolve, reject) => {
      const img = new window.Image();
      img.src = src;
      img.onload = () => resolve();
      img.onerror = () => {
        console.error(`Failed to preload image: ${src}`);
        // Resolve anyway to avoid blocking the UI if an image fails to load
        resolve();
      };
    });
  });

  return Promise.all(imagePromises);
};
